export const invokeApi = (request, onSuccess, onError) => {
    fetch(request)
        .then((res) => {
            res.json()
                .then((data) => {
                    const body = data.body;
                    if (body && body.errorCode !== 0) {
                        onError(body.errorCode, body.errorDescription);
                    } else {
                        onSuccess(data);
                    }
                })
                .catch(() => onError(5000, 'Generic Error'));
        })
        .catch(() => onError(5000, 'Network Error'));
}

export const authHeaders = (token) => ({
    'accept': 'application/json',
    'content-type': 'application/json',
    'Authorization': 'Bearer ' + token
});

export const publicHeaders = {
    'accept': 'application/json',
    'content-type': 'application/json'
};

export const postRequest = (endpoint, headers, body) => {
    const init = { method: 'POST', headers };
    if (body !== undefined) init.body = JSON.stringify(body);
    return new Request(endpoint, init);
};

export const getRequest = (endpoint, headers) =>
    new Request(endpoint, { method: 'GET', headers });
